{
  "id": "campaign-125",
  "name": "Cup Field",
  "seed": "campaign:125",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r....QQQQ....r",
    "..:.......x:..",
    "..:.a....a.:.~",
    "..::::::::::~.",
    "..a.a....a.a..",
    "............,.",
    "...........#,.",
    "....a....a....",
    "::::::::::::::",
    ".....a..a...,,",
    ".a.a......a.a,",
    "......#.......",
    "..::::::::::..",
    ".a:.a..#.a.:a.",
    "..:........:..",
    "S....QQQQ....."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 10,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 12,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 8
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 15
  },
  "generatorVersion": 3,
  "level": 125,
  "biome": "stadium",
  "par": {
    "reel": 7570,
    "push": 6470,
    "selfPropelled": 6042,
    "tractor": 4915,
    "zeroTurn": 4225,
    "fairway": 2823
  },
  "goldTime": {
    "reel": 7450,
    "push": 6470,
    "selfPropelled": 5778,
    "tractor": 4915,
    "zeroTurn": 4225,
    "fairway": 2609
  },
  "routeTries": {
    "par": {
      "reel": 13,
      "push": 6,
      "selfPropelled": 9,
      "tractor": 4,
      "zeroTurn": 8,
      "fairway": 12
    },
    "gold": {
      "reel": 42,
      "push": 6,
      "selfPropelled": 41,
      "tractor": 4,
      "zeroTurn": 8,
      "fairway": 35
    }
  }
}
